import { Avatar, notification } from "antd";
import React from "react";
import instagramFormatter from "../../utils/instagramFormatter";
//components
import { LikesAndComments } from "./instaUtils";
import {
  getPostUrl,
  getShortcodeImageSrc,
  getProfileImageSrc,
} from "../../utils/socialPlatforms";

let timeout; //controls timing of closing notification
const openPostModal = post => {
  const manualScreenshot = post.metadata && post.metadata.manual_screenshot;

  const { shortcodes } = post.relations;
  const avatarSrc = getProfileImageSrc({
    profilePlatform: post.profilePlatform,
    profileHandle: post.profileHandle,
  });

  const config = {
    key: "post", //single key
    message: (
      <a
        rel="noopener noreferrer"
        href={getPostUrl({
          shortcodeId: post.shortcodeId,
          profilePlatform: post.profilePlatform,
          profileHandle: post.profileHandle,
        })}
        target="_blank"
      >
        <Avatar className="icon-marginRight" size="small" src={avatarSrc} />
        {post.profileHandle}
      </a>
    ),
    description: (
      <div>
        <img
          alt=""
          style={{ maxHeight: "50vh" }}
          src={
            manualScreenshot ||
            getShortcodeImageSrc({
              profilePlatform: post.profilePlatform,
              shortcodeId: post.shortcodeId,
            })
          }
        />
        <LikesAndComments
          likes={shortcodes.likes}
          comments={shortcodes.comments}
        />
        {shortcodes.caption && (
          <p
            dangerouslySetInnerHTML={{
              __html: instagramFormatter(shortcodes.caption),
            }}
            style={{ lineHeight: "95%" }}
          />
        )}
      </div>
    ),
    // btn,
    // key,
    //layout
    placement: "topRight",
    top: 48,
    duration: 0,
  };
  notification.open(config);
};

//import below 2 functions as OnMouseEnter and OnMouseLeave events to show/clsoe modals
export const shortcodeModalMouseEnter = record => {
  clearTimeout(timeout);
  //open modal if shortcode
  if (record.done === true) openPostModal(record);
};

export const shortcodeModalMouseLeave = () => {
  clearTimeout(timeout);
  timeout = setTimeout(() => {
    notification.close("post");
  }, 1000); //close modal in 2 sec
};
